// extracted by mini-css-extract-plugin
module.exports = {"proceed-button":"Modal_proceed-button__lzEBZ","cancel-button":"Modal_cancel-button__2LdIk"};